import { Component } from 'react';
import { Tooltip } from 'react-tooltip';

import { getId } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface DirectionArrawProps {
    name?: string;
    className?: string;
    degree: number;
}

interface DirectionArrawState {
    degree: number;
    uuid: string;
}

class DirectionArraw extends Component<DirectionArrawProps, DirectionArrawState> {
    constructor(props: DirectionArrawProps) {
        super(props);
        this.state = {
            degree: 0,
            uuid: getId(),
        };
    }

    static getDerivedStateFromProps(props: DirectionArrawProps, state: DirectionArrawState) {
        if (props.degree !== state.degree) {
            return {
                degree: props.degree,
            };
        }
        return null;
    }

    render() {
        return (
            <>
                <Tooltip
                    id={this.state.uuid}
                    html={`${this.props.name} ${this.state.degree} ${translate('deg')}`}
                    place="top"
                />
                <svg
                    data-tooltip-id={this.state.uuid}
                    className="w-3 h-3 "
                    viewBox="0 0 24 24"
                    style={{
                        fill: 'transparent',
                        transform: `rotateZ(${this.state.degree}deg)`,
                    }}
                    strokeWidth="2"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 20v-8h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v8a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"></path>
                </svg>
            </>
        );
    }
}

export default DirectionArraw;
